module.exports = __webpack_public_path__ + "img/belize.a4b52ad2.svg";